import React from 'react';
import { ToggleWrapper, ToggleTrack, ToggleThumb } from './SHDToggle.styles';
import { SHDToggleProps } from './SHDToggle.d';

const SHDToggle: React.FC<SHDToggleProps> = ({
  isOn,
  onToggle,
  disabled = false,
}) => {
  return (
    <ToggleWrapper
      onClick={() => !disabled && onToggle(!isOn)}
      disabled={disabled}
      data-testid="toggle-wrapper"
    >
      <ToggleTrack isOn={isOn}>
        <ToggleThumb isOn={isOn} data-testid="toggle-thumb" />
      </ToggleTrack>
    </ToggleWrapper>
  );
};

export default SHDToggle;
